import { useState } from 'react';
import { useStateAuthContext } from '../context'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import noimage from '../assets/img/man.png';

const Kendaraan_cari_detail = () => {
  const { state } = useLocation();
  const { STATE_AUTH } = useStateAuthContext();
  const direct = useNavigate();
  const data = state?._data;
  const keyword = state?._keyword;
  const foto_kendaraan = state?._foto_kendaraan || [];

  // State untuk modal foto
  const [showModal, setShowModal] = useState(false);
  const [selectedFoto, setSelectedFoto] = useState(null);
  const [showUserModal, setShowUserModal] = useState(false);

  if (!STATE_AUTH.is_login) {
    return <Navigate to="/login" />
  }

  // Fungsi untuk membuka modal dengan foto yang dipilih
  const handleOpenModal = (foto) => {
    setSelectedFoto(foto);
    setShowModal(true);
  };

  // Fungsi untuk menutup modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedFoto(null);
  };

  // Fungsi untuk membuka modal foto pengguna
  const handleOpenUserModal = () => {
    setShowUserModal(true);
  };

  // Fungsi untuk menutup modal foto pengguna
  const handleCloseUserModal = () => {
    setShowUserModal(false);
  };

  return (
    <main>
      <div className="container-fluid">
        <div className="row mt-3">
          <div className="col-md-12">
            <h3><strong><i className='fas fa-car'></i> DETAIL KENDARAAN</strong></h3>
          </div>
        </div>
        <hr />
        <button className='btn btn-warning' onClick={() => direct('/admin/kendaraan_cari', { state: { _keyword: keyword } })}>Kembali</button>
        <hr />

        <div className="row mt-3">
          <div className='col-md-12'>
            <h4><strong><i className='fas fa-info-circle'></i> Informasi Pengguna Kendaraan</strong></h4>
            <hr />
            <div className="d-flex justify-content-between align-items-start flex-wrap">
              {/* Bagian Informasi */}
              <ul className='list-group flex-grow-1 me-3 mb-2 shadow-sm'>
                <li className='list-group-item d-flex justify-content-between align-items-center'>
                  <strong>NIP</strong>
                  <span>{data.nip || '(Tidak Tersedia)'}</span>
                </li>

                <li className='list-group-item d-flex justify-content-between align-items-center'>
                  <strong>Nama Pengguna</strong>
                  <span>{data.nama || '(Tidak Tersedia)'}</span>
                </li>

                <li className='list-group-item d-flex justify-content-between align-items-center'>
                  <strong>Jabatan</strong>
                  <span>{data.jabatan || '(Tidak Tersedia)'}</span>
                </li>
                <li className='list-group-item d-flex justify-content-between align-items-center bg-light'>
                  <strong>Dokumen BAST</strong>
                  {data.file_bast_pengguna_kendaraan === null
                    ?
                    <span>(Tidak Tersedia)</span>
                    :
                    <a href={data.file_bast_pengguna_kendaraan} target='_blank' rel="noopener noreferrer" className="btn btn-sm btn-primary">
                      <i className="fas fa-eye"></i>&nbsp; Lihat
                    </a>
                  }
                </li>
              </ul>

              {/* Foto Pengguna */}
              <div className="text-center">
                <img
                  src={data.foto || noimage}
                  alt="Foto Pengguna"
                  className="img-thumbnail shadow-sm"
                  style={{
                    width: "175px",
                    height: "175px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    cursor: "pointer"
                  }}
                  onClick={handleOpenUserModal}
                />
                <div className="mt-1 small text-muted">
                  Foto Pengguna
                </div>
              </div>

            </div>
          </div>
          {/* Informasi Kendaraan - Kiri */}
          <div className="col-md-6">
            <h4><strong><i className='fas fa-info-circle'></i> Informasi Kendaraan</strong></h4>
            <hr />
            <ul className='list-group'>
              <li className='list-group-item d-flex flex-column'>
                <small>Kode Barang</small>
                <p className='p-0 m-0 fw-bold'>{data.kode_barang}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Nama Barang</small>
                <p className='p-0 m-0 fw-bold'>{data.nama_barang}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Merk Type</small>
                <p className='p-0 m-0 fw-bold'>{data.merk_type}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Jenis</small>
                <p className='p-0 m-0 fw-bold'>{data.jenis}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Sub Jenis</small>
                <p className='p-0 m-0 fw-bold'>{data.sub_jenis}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Aset Opd</small>
                <p className='p-0 m-0 fw-bold'>{data.opd}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Nomor Polisi</small>
                <p className='p-0 m-0 fw-bold'>{data.no_polisi}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Nomor BPKB</small>
                <p className='p-0 m-0 fw-bold'>{data.no_bpkb}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Nomor Mesin</small>
                <p className='p-0 m-0 fw-bold'>{data.no_mesin}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Nomor Rangka</small>
                <p className='p-0 m-0 fw-bold'>{data.no_rangka}</p>
              </li>
              <li className='list-group-item d-flex flex-column'>
                <small>Status Lelang</small>
                <p className='p-0 m-0 fw-bold'>{data.status_lelang ? data.status_lelang : '(Tidak tersedia)'}</p>
              </li>
            </ul>
          </div>

          {/* Foto Kendaraan - Kanan */}
          <div className="col-md-6">
            <h4><strong><i className='fas fa-images'></i> Foto Kendaraan</strong></h4>
            <hr />
            {foto_kendaraan && foto_kendaraan.length > 0 ? (
              <div className="row">
                {foto_kendaraan.map((foto, index) => (
                  <div key={index} className="col-md-6 mb-3">
                    <div className="card">
                      <div className="card-body text-center">
                        <h6 className="card-title">Foto {index + 1}</h6>
                        {foto.file_gambar ? (
                          <img
                            src={foto.file_gambar}
                            alt={`Foto kendaraan ${index + 1}`}
                            className="img-fluid img-thumbnail"
                            style={{ maxHeight: '200px', objectFit: 'cover', cursor: 'pointer' }}
                            onClick={() => handleOpenModal(foto)}
                          />
                        ) : (
                          <div className="bg-light d-flex align-items-center justify-content-center" style={{ height: '200px' }}>
                            <span className="text-muted">Tidak ada gambar</span>
                          </div>
                        )}
                        <p className="mt-2 mb-0">
                          <small className="text-muted">{foto.nama_gambar || 'Nama file tidak tersedia'}</small>
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="alert alert-info">
                Tidak ada foto tersedia untuk kendaraan ini.
              </div>
            )}
          </div>
        </div>

        {/* Modal untuk menampilkan foto besar */}
        {showModal && (
          <>
            <div className="modal-backdrop show" onClick={handleCloseModal}></div>
            <div className={`modal d-block`} tabIndex="-1" role="dialog" style={{ display: 'block' }}>
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Detail Foto Kendaraan</h5>
                    <button type="button" className="btn-close" onClick={handleCloseModal} aria-label="Close"></button>
                  </div>
                  <div className="modal-body text-center">
                    {selectedFoto && selectedFoto.file_gambar ? (
                      <div>
                        <img
                          src={selectedFoto.file_gambar}
                          alt="Foto kendaraan besar"
                          className="img-fluid mb-3"
                          style={{ maxHeight: '70vh', objectFit: 'contain' }}
                        />
                        <div className="row">
                          <div className="col-md-12">
                            <p className="mb-1"><strong>Nama File:</strong> {selectedFoto.nama_gambar}</p>
                            <p className="mb-1"><strong>File:</strong> <a href={selectedFoto.file_gambar} target="_blank" rel="noopener noreferrer">Lihat Asli</a></p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p>Foto tidak tersedia</p>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Tutup</button>
                  </div>
                </div>
              </div>
            </div>

            {/* Tambahkan style untuk backdrop */}
            <style jsx>{`
              .modal-backdrop {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,.5);
                z-index: 1050;
              }
            `}</style>
          </>
        )}

        {/* Modal untuk informasi pengguna */}
        {showUserModal && (
          <>
            <div className="modal-backdrop show" onClick={handleCloseUserModal}></div>
            <div className={`modal d-block`} tabIndex="-1" role="dialog" style={{ display: 'block' }}>
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Informasi Pengguna</h5>
                    <button type="button" className="btn-close" onClick={handleCloseUserModal} aria-label="Close"></button>
                  </div>
                  <div className="modal-body text-center">
                    <img
                      src={data?.foto || noimage}
                      alt="Foto Pengguna"
                      className="img-fluid rounded shadow"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "400px",
                        objectFit: "contain"
                      }}
                    />
                    <br />
                    <div className="mt-4">
                      <ul className="list-group">
                        <li className='list-group-item d-flex justify-content-between align-items-center'>
                          <strong>NIP</strong>
                          <span>{data?.nip || '(Tidak Tersedia)'}</span>
                        </li>

                        <li className='list-group-item d-flex justify-content-between align-items-center'>
                          <strong>Nama Pengguna</strong>
                          <span>{data?.nama || '(Tidak Tersedia)'}</span>
                        </li>

                        <li className='list-group-item d-flex justify-content-between align-items-center'>
                          <strong>Jabatan</strong>
                          <span>{data?.jabatan || '(Tidak Tersedia)'}</span>
                        </li>

                        <li className='list-group-item d-flex justify-content-between align-items-center bg-light'>
                          <strong>Dokumen BAST</strong>
                          {data?.file_bast_pengguna_kendaraan === null
                            ?
                            <span>(Tidak Tersedia)</span>
                            :
                            <a href={data?.file_bast_pengguna_kendaraan} target='_blank' rel="noopener noreferrer" className="btn btn-sm btn-primary">
                              <i className="fas fa-eye"></i>&nbsp; Lihat
                            </a>
                          }
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={handleCloseUserModal}>
                      Tutup
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Tambahkan style untuk backdrop */}
            <style jsx>{`
              .modal-backdrop {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,.5);
                z-index: 1050;
              }
            `}</style>
          </>
        )}
      </div>
    </main>
  )
}

export default Kendaraan_cari_detail